import React from "react";
import AssamMap from "./AssamMap";
import Top10FacilitiesChart from "./Top10FacilitiesChart";
import "./DashboardCharts.css";

const Chart1 = () => {
  return (
    <div className="chart1-container">
      <AssamMap />
      <Top10FacilitiesChart />
    </div>
  );
};

export default Chart1;
